import { render, staticRenderFns } from "./StandaloneReleaseVersions.vue?vue&type=template&id=1307367e&scoped=true&"
import script from "./StandaloneReleaseVersions.vue?vue&type=script&lang=js&"
export * from "./StandaloneReleaseVersions.vue?vue&type=script&lang=js&"
import style0 from "./StandaloneReleaseVersions.vue?vue&type=style&index=0&id=1307367e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1307367e",
  null
  
)

export default component.exports